import React, { useState, useRef, useEffect } from "react";
import "./style/labOrderPage.css";

import { MdPrint, MdSyncAlt } from "react-icons/md";
import { FaUserCheck, FaEnvelopeOpenText } from "react-icons/fa";
import { IoMdArrowDroprightCircle } from "react-icons/io";
import { FcCancel, FcApproval } from "react-icons/fc";
import { AiOutlineClose } from "react-icons/ai";
import { TfiReload } from "react-icons/tfi";
import { GrTest } from "react-icons/gr";
import { TbTruckDelivery } from "react-icons/tb";
import { GiStamper } from "react-icons/gi";

import { Form, Row, Col } from "react-bootstrap";
import ButtonWithIcon from "../Common/Button/ButtonWithIcon";
import DashboardSingleCard from "../Dashboard/DashboardSingleCard";
import AddToShippingManifest from "../Modal/MangeLabOrder/AddToShippingManifest";
import ConfirmationDialogWithComment from "../Modal/MangeLabOrder/ConfirmationDialogWithComment";

import ApiService from "../../ApiService";
import { isValidValue } from "../../util/common";
import { parseAxiosError } from "../../util/parserHelper";
import MuiAlert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";
import { ORDER_SEGMENTS } from "./ORDER_SEGMENTS";
import { LOCATION_FILTER_OPTIONS } from "./LOCATION_FILTER_OPTIONS";
import { tableColumns } from "./tableColumns";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function ManageLabOrder() {
  const [loading, setLoading] = useState(false);
  const tableRef = useRef(null);
  const [locationCode, setLocationCode] = useState("");
  const [activeCard, setActiveCard] = useState(ORDER_SEGMENTS.COLLECTED_SAMPLES.val);

  const [showAddToShippingManifest, setShowAddToShippingManifest] = useState(false);
  const [collectedStatusOrders, setCollectedStatusOrders] = useState([]);
  const [approvedStatusOrders, setApprovedStatusOrders] = useState([]);
  const [shipmentManifestUpdatedOrders, setShipmentManifestUpdatedOrders] = useState([]);
  const [currViewData, setCurrViewData] = useState([]);
  const [selectedLabOrders, setSelectedLabOrders] = useState([]);
  const [collectedSampleCount, setCollectedSampleCount] = useState(0);
  const [approvedSampleCount, setApprovedSampleCount] = useState(0);
  const [shipmentManifestCount, setShipmentManifestCount] = useState(0);
  const [refreshDataToggle, setRefreshDataToggle] = useState(false);

  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [cancelComment, setCancelComment] = useState("");
  const [showApproveDialog, setShowApproveDialog] = useState(false);
  const [showConfirmShipmentDialog, setShowConfirmShipmentDialog] = useState(false);
  const [approveComment, setApproveComment] = useState("");
  const [confirmShipmentComment, setConfirmShipmentComment] = useState("");
  const [apiLoading, setApiLoading] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackText, setSnackText] = useState("");
  const [snackSeverity, setSnackSeverity] = useState("");
  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  const cards = [
    {
      heading: ORDER_SEGMENTS.COLLECTED_SAMPLES.heading,
      type: ORDER_SEGMENTS.COLLECTED_SAMPLES.val,
      count: collectedSampleCount,
      IconComponent: <GrTest />,
      isLast: false
    },
    {
      heading: ORDER_SEGMENTS.APPROVED_SAMPLES.heading,
      type: ORDER_SEGMENTS.APPROVED_SAMPLES.val,
      count: approvedSampleCount,
      IconComponent: <GiStamper />,
      isLast: false
    },
    {
      heading: ORDER_SEGMENTS.CONFIRM_SHIPMENT.heading,
      type: ORDER_SEGMENTS.CONFIRM_SHIPMENT.val,
      count: shipmentManifestCount,
      IconComponent: <TbTruckDelivery />,
      isLast: true
    }
  ];

  const getLabOrderIn_SampleCollectedStatus = async () => {
    setApiLoading(true);
    try {
      const response = await ApiService.getKitByStatus("SAMPLE_COLLECTED_PENDING_REVIEW");
      setCollectedStatusOrders(response?.data);
    } catch (error) {
      console.log("Error while calling api", error);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(
        `Failed to get Lab Orders in Sample Collected status, msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`
      );
    } finally {
      setApiLoading(false);
    }
  };

  const getLabOrderIn_SampleApprovedStatus = async () => {
    setApiLoading(true);
    try {
      const response = await ApiService.getKitByStatus("SAMPLE_APPROVED_PENDING_SHIPMENT_MANIFEST");
      setApprovedStatusOrders(response?.data);
    } catch (error) {
      console.log("Error while calling api", error);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(
        `Failed to get Lab Orders in Sample Approved status, msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`
      );
    } finally {
      setApiLoading(false);
    }
  };

  const getLabOrderIn_SampleShipmentManifestCollected = async () => {
    setApiLoading(true);
    try {
      const response = await ApiService.getKitByStatus("SAMPLE_PENDING_SHIPMENT_MANIFEST_CONFIRMATION");
      setShipmentManifestUpdatedOrders(response?.data);
    } catch (error) {
      console.log("Error while calling api", error);

      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(
        `Failed to get Lab Orders in Sample Shipment Manifest Created status, msg: ${parseAxiosError(error)?.message}, reason: ${
          parseAxiosError(error)?.reason
        }`
      );
    } finally {
      setApiLoading(false);
    }
  };

  const refreshData = async () => {
    setLoading(true);
    try {
      await getLabOrderIn_SampleCollectedStatus();
      await getLabOrderIn_SampleApprovedStatus();
      await getLabOrderIn_SampleShipmentManifestCollected();
    } catch (err) {
      alert(`Failed to refresh data, msg: ${parseAxiosError(err)?.message}, reason: ${parseAxiosError(err)?.reason}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      await refreshData();
      setSelectedLabOrders([]);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      await refreshData();
      setSelectedLabOrders([]);
    })();
  }, [refreshDataToggle]);

  useEffect(() => {
    if (isValidValue(locationCode)) {
      setCollectedSampleCount(collectedStatusOrders?.filter(order => order.careLocationCode === locationCode)?.length);
      setApprovedSampleCount(approvedStatusOrders?.filter(order => order.careLocationCode === locationCode)?.length);
      setShipmentManifestCount(shipmentManifestUpdatedOrders?.filter(order => order.careLocationCode === locationCode)?.length);
    }

    if (!isValidValue(activeCard) || !isValidValue(locationCode)) {
      setCurrViewData([]);
      setSelectedLabOrders([]);
      return;
    }
    if (activeCard === ORDER_SEGMENTS.COLLECTED_SAMPLES.val) {
      const data = collectedStatusOrders?.filter(order => order.careLocationCode === locationCode);
      setCurrViewData(data);
    } else if (activeCard === ORDER_SEGMENTS.APPROVED_SAMPLES.val) {
      const data = approvedStatusOrders?.filter(order => order.careLocationCode === locationCode);
      setCurrViewData(data);
    } else if (activeCard === ORDER_SEGMENTS.CONFIRM_SHIPMENT.val) {
      const data = shipmentManifestUpdatedOrders?.filter(order => order.careLocationCode === locationCode);
      setCurrViewData(data);
    }
    setSelectedLabOrders([]);
  }, [activeCard, locationCode, collectedStatusOrders, approvedStatusOrders, shipmentManifestUpdatedOrders]);

  const printShippingLabel = async orderData => {
    const labelS3FileUrl = orderData?.sampleLabelPdfS3Url;
    if (!isValidValue(labelS3FileUrl)) {
      alert("No label found for this kit. Contact tech");
      return;
    }
    const resp = await ApiService.getPresignedUrl(labelS3FileUrl);
    const preSignedUrl = resp?.data?.body?.url;
    if (!isValidValue(preSignedUrl)) {
      alert("No label found for this kit. Contact tech");
      return;
    }
    //open in new window and show print dialog
    const newWindow = window.open(preSignedUrl, "_blank");
    newWindow.onload = function() {
      newWindow.print();
    };
  };

  const cancelLabOrders = async data => {
    setLoading(true);
    try {
      const response = await ApiService.cancelLabOrders({
        kitIds: data.kitIdArr?.join(","),
        comment: cancelComment
      });
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Lab Orders Cancelled Successfully");
      setRefreshDataToggle(!refreshDataToggle);
      setCancelComment("");
    } catch (error) {
      console.log("Error while cancelling lab orders", error);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(`Failed to cancel Lab Orders. msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`);
    } finally {
      setLoading(false);
      setShowCancelDialog(false);
    }
  };

  const approveLabOrderSamples = async data => {
    setLoading(true);
    try {
      const response = await ApiService.approveLabOrderSamples({
        kitIds: data?.kitIdArr?.join(","),
        comment: data.comment
      });
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Lab Orders Approved Successfully");
      setRefreshDataToggle(!refreshDataToggle);
    } catch (error) {
      console.log("Error while approving lab orders", error);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(`Failed to approve Lab Orders. msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`);
    } finally {
      setLoading(false);
      setApproveComment("");
      setShowApproveDialog(false);
    }
  };

  const confirmShippingManifest = async data => {
    setLoading(true);
    try {
      const response = await ApiService.confirmLabOrderShippingManifest({
        kitIds: data.kitIdArr?.join(","),
        comment: data.comment
      });
      // alert("Shipping Confirmed Successfully");
      setSnackOpen(true);
      setSnackSeverity("success");
      setSnackText("Shipping Confirmed Successfully");
      setRefreshDataToggle(!refreshDataToggle);
    } catch (error) {
      console.log("Error while confirming shipping manifest", error);
      // alert(`Failed to confirm Shipping Manifest. msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`);
      setSnackOpen(true);
      setSnackSeverity("error");
      setSnackText(`Failed to confirm Shipping Manifest. msg: ${parseAxiosError(error)?.message}, reason: ${parseAxiosError(error)?.reason}`);
    } finally {
      setLoading(false);
    }
  };

  const viewDetailsActionClick = rowData => {
    window.open(`/KitDetails?kitId=${rowData?.kitId}`, "_blank");
  };
  const viewPatientProfileActionClick = rowData => {
    window.open(`/PatientProfile?patientId=${rowData?.patientId}`, "_blank");
  };

  const goToBookingDetail = rowData => {
    window.open(`/BookingDetails?bookingId=${rowData?.bookingId}`, "_blank");
  };

  const collectedSamplesAction = [
    {
      icon: () => (
        <FaUserCheck
          style={{
            color: "green"
          }}
        />
      ),
      tooltip: "Approve",
      onClick: (event, rowData) => setShowApproveDialog(true)
    },
    {
      icon: () => <FcCancel />,
      tooltip: "Cancel",
      onClick: (event, rowData) => setShowCancelDialog(true)
    },
    {
      tooltip: "Print Label",
      icon: () => <MdPrint style={{ color: "gray" }} />,

      onClick: (event, rowData) => printShippingLabel(rowData)
    }
  ];

  const samplesReadyForShipmentActions = [
    {
      tooltip: "Print Label",
      icon: () => <MdPrint style={{ color: "gray" }} />,
      onClick: (event, rowData) => printShippingLabel(rowData)
    }
  ];

  const approvedAction = [
    {
      tooltip: "Print Label",
      icon: () => <MdPrint style={{ color: "gray" }} />,
      onClick: (event, rowData) => printShippingLabel(rowData)
    }
  ];

  const handleCardClick = type => {
    setActiveCard(type);
  };

  const handleSelectAll = event => {
    const isChecked = event.target.checked;
    setSelectedLabOrders(isChecked ? currViewData : []);
  };

  const handleRowDataSelection = (event, data) => {
    const isChecked = event.target.checked;
    const selectedOrders = isChecked ? [...selectedLabOrders, data] : selectedLabOrders.filter(order => order.kitId !== data.kitId);
    setSelectedLabOrders(selectedOrders);
  };

  return (
    <div className="page">
      <Snackbar open={snackOpen} autoHideDuration={6000} onClose={handleSnackClose} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={handleSnackClose} severity={snackSeverity}>
          {snackText}
        </Alert>
      </Snackbar>
      <ConfirmationDialogWithComment
        isShow={showCancelDialog}
        onSubmit={() => {
          if(!selectedLabOrders?.length) {
            alert("Please select atleast one order to cancel");
            return;
          }
          cancelLabOrders({ kitIdArr: selectedLabOrders?.map(order => order.kitId), comment: cancelComment });
        }}
        modalProps={{
          title: "Cancel Lab Orders",
          commentLabel: "Cancel Comment",
          commentError: "Please provide a comment for cancellation",
          buttonSubmitText: "Cancel"
        }}
        onClose={() => setShowCancelDialog(false)}
        comment={cancelComment}
        setComment={setCancelComment}
        isLoading={loading}
      />
      <ConfirmationDialogWithComment
        isShow={showApproveDialog}
        onSubmit={() => {
          if(!selectedLabOrders?.length) {
            alert("Please select atleast one order to approve");
            return;
          }
          approveLabOrderSamples({ kitIdArr: selectedLabOrders?.map(order => order.kitId), comment: approveComment });
        }}
        modalProps={{
          title: "Approve Lab Orders",
          commentLabel: "This will send the order request(s) to the lab. Confirm with a comment.",
          commentError: "Please provide a comment for approval",
          buttonSubmitText: "Approve"
        }}
        onClose={() => setShowApproveDialog(false)}
        comment={approveComment}
        setComment={setApproveComment}
        isLoading={loading}
      />

      <ConfirmationDialogWithComment
          isShow={showConfirmShipmentDialog}
          onSubmit={() => {
            if(!shipmentManifestUpdatedOrders?.length) {
              alert("No orders to confirm shipment");
              return;
            }
            confirmShippingManifest({ kitIdArr: shipmentManifestUpdatedOrders?.map(order => order.kitId), comment: confirmShipmentComment });
          }}
          modalProps={{
            title: "Confirm Lab Order Shipment",
            commentLabel: "id you print the manifest? This will clear the lab order view. Last chance to print it",
            commentError: "Please provide a comment",
            buttonSubmitText: "Confirm Shipment"
          }}
          onClose={() => setShowConfirmShipmentDialog(false)}
          comment={confirmShipmentComment}
          setComment={setConfirmShipmentComment}
          isLoading={loading}
      />

      <AddToShippingManifest
        carehubLocation={LOCATION_FILTER_OPTIONS.find(option => option.value === locationCode)?.label}
        showModal={showAddToShippingManifest}
        closeModal={() => {
          setShowAddToShippingManifest(false);
          setRefreshDataToggle(!refreshDataToggle);
        }}
        manifestData={activeCard === ORDER_SEGMENTS.CONFIRM_SHIPMENT.val ? shipmentManifestUpdatedOrders?.filter(order => order.careLocationCode === locationCode) : selectedLabOrders}
      />
      <div className={`section-1 `}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row"
          }}
        >
          <h1 className="heading mar-t-2">Manage Lab Order</h1>
          <TfiReload
            onClick={refreshData}
            isLoading={loading}
            size={30}
            style={{
              cursor: "pointer",
              marginLeft: "20px",
              color: loading ? "gray" : "black",
              marginTop: "15px",
              // if loading is true, then rotate the icon
              animation: loading ? "spin 1s linear infinite" : "none"
            }}
          />
        </div>
        <div>
          <div className="filter-section">
            {locationCode && (
              <Form>
                <Form.Group controlId="exampleForm.ControlSelect1">
                  {/* <Form.Label>Care Location</Form.Label> */}
                  <Form.Control
                    size="lg"
                    as="select"
                    value={locationCode}
                    onChange={e => {
                      setLocationCode(e.target.value);
                    }}
                  >
                    {LOCATION_FILTER_OPTIONS.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            )}
          </div>
        </div>
      </div>
      {!locationCode && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column"
          }}
        >
          <h1 className={`heading mar-t-2 ${locationCode ? "hide" : ""}`}>Select a care location to proceed</h1>
          <Col>
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "row"
              }}
            >
              <Form>
                <Form.Group controlId="exampleForm.ControlSelect1" className={` ${locationCode ? "hide" : ""}`}>
                  <Form.Control
                    size="lg"
                    as="select"
                    value={locationCode}
                    onChange={e => {
                      setLocationCode(e.target.value);
                    }}
                  >
                    {LOCATION_FILTER_OPTIONS.map(option => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>
              </Form>
            </Row>
          </Col>
        </div>
      )}
      <div className={`content-container ${!locationCode ? "hide" : ""}`}>
        <div className="section-2">
          <div className="dashboard-cards">
            {cards.map(card => (
              <>
                <DashboardSingleCard
                  key={card.heading}
                  heading={card.heading}
                  count={card.count}
                  IconComponent={card.IconComponent}
                  isActive={activeCard === card.type}
                  onClick={() => handleCardClick(card.type)}
                  isAttentionRequired={card.isFocus && card.count > 0}
                />
                {card.isLast === false && <IoMdArrowDroprightCircle />}
              </>
            ))}
          </div>
        </div>
      </div>
      {!apiLoading && (
        <div className={`table-cont ${!locationCode ? "hide" : ""}`}>
          <div className="dashboard-table-cont">
            <div className={`dashboard-table`}>
              <div className="table-container">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: "row",
                    backgroundColor: "#f5f5f5"
                  }}
                >
                  <h2 className="heading">
                    {Object.values(ORDER_SEGMENTS).map(segment => {
                      if (segment.val === activeCard) {
                        return segment.heading;
                      }
                    }) || ""}
                  </h2>
                  {activeCard === ORDER_SEGMENTS.COLLECTED_SAMPLES.val && selectedLabOrders?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row"
                      }}
                    >
                      <ButtonWithIcon
                        btnTitle="Approve Orders"
                        cbFunc={data => {
                          setShowApproveDialog(true);
                        }}
                        data={true}
                        Icon={FcApproval}
                        ButtonStyle={{ backgroundColor: "green", color: "white" }}
                        isLoading={loading}
                      />

                      <ButtonWithIcon
                        btnTitle="Cancel Orders"
                        cbFunc={data => {
                          setShowCancelDialog(data);
                        }}
                        data={true}
                        Icon={AiOutlineClose}
                        ButtonStyle={{ backgroundColor: "#DC3545", color: "white" }}
                        IconStyle={{ color: "white" }}
                        isLoading={loading}
                      />
                    </div>
                  )}

                  {activeCard === ORDER_SEGMENTS.APPROVED_SAMPLES.val && selectedLabOrders?.length > 0 && (
                    <ButtonWithIcon
                      btnTitle="Add Shipping Details"
                      cbFunc={setShowAddToShippingManifest}
                      data={true}
                      Icon={MdSyncAlt}
                      ButtonStyle={{ backgroundColor: "#0D6EFD", color: "white" }}
                      isLoading={loading}
                    />
                  )}

                  {activeCard === ORDER_SEGMENTS.CONFIRM_SHIPMENT.val && shipmentManifestUpdatedOrders?.length > 0 && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-end"
                      }}
                    >
                      <ButtonWithIcon
                        btnTitle="Confirm Shipment"
                        cbFunc={setShowConfirmShipmentDialog}
                        data={true}
                        Icon={MdSyncAlt}
                        ButtonStyle={{ backgroundColor: "green", color: "white" }}
                        isLoading={loading}
                      />
                      <ButtonWithIcon
                        btnTitle="Print Shipping Manifest"
                        cbFunc={setShowAddToShippingManifest}
                        data={true}
                        Icon={MdPrint}
                        ButtonStyle={{ backgroundColor: "#0D6EFD", color: "white" }}
                        isLoading={loading}
                      />
                    </div>
                  )}
                </div>

                <div ref={tableRef}>
                  <table className="table">
                    <thead>
                      <tr>
                        {activeCard !== ORDER_SEGMENTS.CONFIRM_SHIPMENT.val && (
                          <th>
                            <input
                              type="checkbox"
                              value={"allSelected"}
                              onClick={event => {
                                handleSelectAll(event);
                              }}
                              checked={currViewData.length === selectedLabOrders.length}
                            />
                          </th>
                        )}
                        {tableColumns.map(column => (
                          <th key={column.title}>{column.title}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {currViewData.map((data, index) => {
                        return (
                            <tr key={index}>
                              {activeCard !== ORDER_SEGMENTS.CONFIRM_SHIPMENT.val && (
                                  <td>
                                    <input
                                        type="checkbox"
                                        onClick={event => {
                                          handleRowDataSelection(event, data);
                                        }}
                                        checked={selectedLabOrders.some(sample => sample.kitId === data.kitId)}
                                    />
                                  </td>
                              )}
                              {/*// )}*/}
                              <td onClick={() => viewDetailsActionClick(data)} className="hyperlink">
                                {data.reqId}
                              </td>
                              <td className="hyperlink" onClick={() => viewDetailsActionClick(data)}>
                                {data.kitId}
                              </td>

                              <td className="hyperlink" onClick={() => goToBookingDetail(data)}>
                                {data.bookingId}
                              </td>
                              <td className="hyperlink" onClick={() => viewPatientProfileActionClick(data)}>
                                {data.name}
                              </td>
                              <td>{data.dob}</td>
                              <td className="hyperlink" onClick={() => viewPatientProfileActionClick(data)}>
                                {data.email}
                              </td>
                              <td>{data.careLocation}</td>
                              <td>{data.clinicianName}</td>
                              <td>{data.labName}</td>
                              <td>
                                {data.panelName?.split("W/").map((panel, index) => (
                                    <div key={index}>{panel}</div>
                                ))}
                              </td>
                              <td>{data.sampleTakenDate}</td>
                              {activeCard === ORDER_SEGMENTS.COLLECTED_SAMPLES.val && (
                                  <td
                                      style={{
                                        minWidth: "200px",
                                        width: "200px"
                                      }}
                                  >
                                    {collectedSamplesAction.map((action, index) => (
                                        <span
                                            key={index}
                                            className="icon-tooltip"
                                            onClick={() => {
                                              console.log("clicked");
                                              console.log(action);
                                              action.onClick(null, data);
                                            }}
                                        >
                                    <span class="tooltiptext">{action.tooltip}</span>
                                    <span
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px"
                                        }}
                                    >
                                      {action.icon()}
                                    </span>
                                  </span>
                                    ))}
                                  </td>
                              )}
                              {activeCard === ORDER_SEGMENTS.CONFIRM_SHIPMENT.val && (
                                  <td>
                                    {samplesReadyForShipmentActions.map((action, index) => (
                                        <span
                                            key={index}
                                            className="icon-tooltip"
                                            onClick={() => {
                                              action.onClick(null, data);
                                            }}
                                        >
                                    <span class="tooltiptext">{action.tooltip}</span>
                                    <span
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px"
                                        }}
                                    >
                                      {action.icon()}
                                    </span>
                                  </span>
                                    ))}
                                  </td>
                              )}
                              {activeCard === ORDER_SEGMENTS.APPROVED_SAMPLES.val && (
                                  <td>
                                    {approvedAction.map((action, index) => (
                                        <span
                                            key={index}
                                            className="icon-tooltip"
                                            onClick={() => {
                                              action.onClick(null, data);
                                            }}
                                        >
                                    <span class="tooltiptext">{action.tooltip}</span>
                                    <span
                                        style={{
                                          cursor: "pointer",
                                          marginRight: "10px"
                                        }}
                                    >
                                      {action.icon()}
                                    </span>
                                  </span>
                                    ))}
                                  </td>
                              )}
                            </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {apiLoading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "45vh",
            width: "100%"
          }}
        >
          <div className="loading"></div>
        </div>
      )}
    </div>
  );
}

export default ManageLabOrder;
